/** US and major international airports for consulting inquiry dropdowns */

export const flightAirportGroups = [
  {
    label: 'United States',
    airports: [
      ['ATL', 'Atlanta, GA — Hartsfield-Jackson'],
      ['AUS', 'Austin, TX — Austin-Bergstrom'],
      ['BWI', 'Baltimore, MD — Baltimore/Washington'],
      ['BOS', 'Boston, MA — Logan'],
      ['CLT', 'Charlotte, NC — Douglas'],
      ['ORD', 'Chicago, IL — O\'Hare'],
      ['MDW', 'Chicago, IL — Midway'],
      ['CVG', 'Cincinnati, OH — Cincinnati/N. Kentucky'],
      ['CLE', 'Cleveland, OH — Hopkins'],
      ['CMH', 'Columbus, OH — John Glenn'],
      ['DFW', 'Dallas/Fort Worth, TX — DFW'],
      ['DAL', 'Dallas, TX — Love Field'],
      ['DEN', 'Denver, CO — Denver Intl'],
      ['DTW', 'Detroit, MI — Metro Wayne County'],
      ['FLL', 'Fort Lauderdale, FL'],
      ['RSW', 'Fort Myers, FL'],
      ['HNL', 'Honolulu, HI — Daniel K. Inouye'],
      ['IAH', 'Houston, TX — George Bush'],
      ['HOU', 'Houston, TX — Hobby'],
      ['IND', 'Indianapolis, IN'],
      ['JAX', 'Jacksonville, FL'],
      ['MCI', 'Kansas City, MO'],
      ['LAS', 'Las Vegas, NV — Harry Reid'],
      ['LAX', 'Los Angeles, CA — LAX'],
      ['SNA', 'Orange County, CA — John Wayne'],
      ['SDF', 'Louisville, KY'],
      ['MEM', 'Memphis, TN'],
      ['MIA', 'Miami, FL'],
      ['MKE', 'Milwaukee, WI'],
      ['MSP', 'Minneapolis/St. Paul, MN'],
      ['BNA', 'Nashville, TN'],
      ['MSY', 'New Orleans, LA'],
      ['JFK', 'New York, NY — JFK'],
      ['LGA', 'New York, NY — LaGuardia'],
      ['EWR', 'Newark, NJ — Liberty'],
      ['OAK', 'Oakland, CA'],
      ['MCO', 'Orlando, FL'],
      ['PHL', 'Philadelphia, PA'],
      ['PHX', 'Phoenix, AZ — Sky Harbor'],
      ['PIT', 'Pittsburgh, PA'],
      ['PDX', 'Portland, OR'],
      ['RDU', 'Raleigh/Durham, NC'],
      ['RIC', 'Richmond, VA'],
      ['SMF', 'Sacramento, CA'],
      ['SLC', 'Salt Lake City, UT'],
      ['SAN', 'San Diego, CA'],
      ['SFO', 'San Francisco, CA — SFO'],
      ['SJC', 'San Jose, CA'],
      ['SEA', 'Seattle, WA — Seattle-Tacoma'],
      ['STL', 'St. Louis, MO'],
      ['TPA', 'Tampa, FL'],
      ['DCA', 'Washington, DC — Reagan National'],
      ['IAD', 'Washington, DC — Dulles'],
    ],
  },
  {
    label: 'Canada & Mexico',
    airports: [
      ['YYZ', 'Toronto, ON — Pearson'],
      ['YVR', 'Vancouver, BC'],
      ['YUL', 'Montreal, QC — Trudeau'],
      ['YYC', 'Calgary, AB'],
      ['MEX', 'Mexico City — Benito Juárez'],
      ['CUN', 'Cancún, Mexico'],
      ['GDL', 'Guadalajara, Mexico'],
    ],
  },
  {
    label: 'Europe',
    airports: [
      ['AMS', 'Amsterdam, Netherlands — Schiphol'],
      ['ATH', 'Athens, Greece'],
      ['BCN', 'Barcelona, Spain'],
      ['BER', 'Berlin, Germany'],
      ['BRU', 'Brussels, Belgium'],
      ['CDG', 'Paris, France — Charles de Gaulle'],
      ['ORY', 'Paris, France — Orly'],
      ['DUB', 'Dublin, Ireland'],
      ['EDI', 'Edinburgh, UK'],
      ['FRA', 'Frankfurt, Germany'],
      ['GVA', 'Geneva, Switzerland'],
      ['IST', 'Istanbul, Turkey'],
      ['LCY', 'London, UK — City'],
      ['LGW', 'London, UK — Gatwick'],
      ['LHR', 'London, UK — Heathrow'],
      ['STN', 'London, UK — Stansted'],
      ['MAD', 'Madrid, Spain'],
      ['MUC', 'Munich, Germany'],
      ['FCO', 'Rome, Italy — Fiumicino'],
      ['ZRH', 'Zurich, Switzerland'],
      ['VIE', 'Vienna, Austria'],
      ['WAW', 'Warsaw, Poland'],
    ],
  },
  {
    label: 'Asia & Middle East',
    airports: [
      ['BKK', 'Bangkok, Thailand — Suvarnabhumi'],
      ['PEK', 'Beijing, China — Capital'],
      ['PVG', 'Shanghai, China — Pudong'],
      ['HKG', 'Hong Kong'],
      ['DEL', 'New Delhi, India — Indira Gandhi'],
      ['BOM', 'Mumbai, India'],
      ['CGK', 'Jakarta, Indonesia'],
      ['KUL', 'Kuala Lumpur, Malaysia'],
      ['MNL', 'Manila, Philippines'],
      ['ICN', 'Seoul, South Korea — Incheon'],
      ['SIN', 'Singapore — Changi'],
      ['TPE', 'Taipei, Taiwan — Taoyuan'],
      ['NRT', 'Tokyo, Japan — Narita'],
      ['HND', 'Tokyo, Japan — Haneda'],
      ['DXB', 'Dubai, UAE'],
      ['DOH', 'Doha, Qatar'],
      ['AUH', 'Abu Dhabi, UAE'],
      ['TLV', 'Tel Aviv, Israel'],
      ['RUH', 'Riyadh, Saudi Arabia'],
      ['JED', 'Jeddah, Saudi Arabia'],
    ],
  },
  {
    label: 'Africa',
    airports: [
      ['CAI', 'Cairo, Egypt'],
      ['CPT', 'Cape Town, South Africa'],
      ['ADD', 'Addis Ababa, Ethiopia'],
      ['NBO', 'Nairobi, Kenya'],
      ['LOS', 'Lagos, Nigeria'],
      ['JNB', 'Johannesburg, South Africa'],
      ['CMN', 'Casablanca, Morocco'],
    ],
  },
  {
    label: 'Latin America & Caribbean',
    airports: [
      ['EZE', 'Buenos Aires, Argentina'],
      ['GRU', 'São Paulo, Brazil — Guarulhos'],
      ['GIG', 'Rio de Janeiro, Brazil — Galeão'],
      ['SCL', 'Santiago, Chile'],
      ['BOG', 'Bogotá, Colombia'],
      ['LIM', 'Lima, Peru'],
      ['SJU', 'San Juan, Puerto Rico'],
      ['NAS', 'Nassau, Bahamas'],
      ['MBJ', 'Montego Bay, Jamaica'],
      ['PTY', 'Panama City, Panama'],
    ],
  },
  {
    label: 'Australia & Pacific',
    airports: [
      ['SYD', 'Sydney, Australia'],
      ['MEL', 'Melbourne, Australia'],
      ['BNE', 'Brisbane, Australia'],
      ['AKL', 'Auckland, New Zealand'],
      ['PPT', 'Papeete, French Polynesia'],
    ],
  },
];

export const formatAirportValue = (code, label) => `${code} — ${label}`;

export const flightAirportSelectGroups = flightAirportGroups.map((group) => ({
  label: group.label,
  options: group.airports.map(([code, label]) => ({
    value: formatAirportValue(code, label),
    label: formatAirportValue(code, label),
  })),
}));
